import React, { useState } from 'react';
import Icon from 'src/react/components/icon/Icon';
import PropTypes from 'prop-types';

const Expander = (props) => {
  const { children, tasks, onChange } = props;
  const [expanded, setExpanded] = useState(true);

  const expand = () => {
    const newExpandedState = !expanded;
    setExpanded(newExpandedState);
    onChange(newExpandedState);
  };

  return (
    <div>
      <button
        className="flex w-full justify-between mb-2"
        data-testid="expander_toggle"
        onClick={expand}
      >
        <span className="text-4 font-normal">Completed ({tasks.length})</span>
        <div>
          <Icon
            name="caret"
            className={`ActionCards-caretIcon ${
              expanded
                ? 'Recommendations-ExpandedCaret'
                : 'Recommendations-Caret'
            }`}
          />
        </div>
      </button>
      <div>
        <div className={expanded ? 'block' : 'is-hidden'}>{children}</div>
      </div>
    </div>
  );
};

Expander.propTypes = {
  children: PropTypes.node,
  tasks: PropTypes.array,
  onChange: PropTypes.func
};

export default Expander;
